module.exports = __webpack_public_path__ + "static/dl2-stay-human_screen1-722f0cab6fdc0fa197683a29dcd656ad.png";